import React from 'react';
import { cn } from '../../../../../../utils/styles';
import AccountFeature from '../Feature';
import { DeliveryTypeEnum, IAccount } from '../../../../Layout/Account/Data';

export interface IAccountInfo {
  account: IAccount;
  label: string;
  handleUpdate: (value: string, key: keyof IAccount) => void;
  isEdit: boolean;
}

const paperlessStyle =
  'border-[#5ECA8F] text-[#5ECA8F] hover:bg-[#5ECA8F] hover:text-white ' +
  'data-[active=true]:bg-[#5ECA8F] data-[active=true]:text-white';
const paperStyle =
  'border-[#1053FF] text-[#1053FF] hover:bg-[#1053FF] hover:text-white ' +
  'data-[active=true]:bg-[#1053FF] data-[active=true]:text-white';
const paperlessAndPaperStyle =
  'border-primary text-primary hover:bg-primary hover:text-white ' +
  'data-[active=true]:bg-primary data-[active=true]:text-white';

function AccountDelivery({ label, isEdit, account, handleUpdate }: IAccountInfo) {
  return (
    <div className="flex gap-[10px]">
      <div className="xl:min-w-[120px] min-w-[100px] text-[12px] uppercase font-medium opacity-60 text-addition1">
        {label}
      </div>
      {!isEdit ? (
        <AccountFeature
          accountKey="deliveryType"
          value={account.deliveryType}
          active
          className={cn(
            'cursor-auto',
            account.deliveryType === DeliveryTypeEnum.paperless && paperlessStyle,
            account.deliveryType === DeliveryTypeEnum.paper && paperStyle,
            account.deliveryType === DeliveryTypeEnum.paperlessAndPaper && paperlessAndPaperStyle,
          )}
        />
      ) : (
        <div>
          <div className="flex flex-wrap gap-[5px] mb-[5px]">
            <AccountFeature
              active={account.deliveryType === DeliveryTypeEnum.paperless}
              accountKey="deliveryType"
              value={DeliveryTypeEnum.paperless}
              className={paperlessStyle}
              handleUpdate={handleUpdate}
            />
            <AccountFeature
              active={account.deliveryType === DeliveryTypeEnum.paper}
              accountKey="deliveryType"
              value={DeliveryTypeEnum.paper}
              className={paperStyle}
              handleUpdate={handleUpdate}
            />
            <AccountFeature
              active={account.deliveryType === DeliveryTypeEnum.paperlessAndPaper}
              accountKey="deliveryType"
              value={DeliveryTypeEnum.paperlessAndPaper}
              className={paperlessAndPaperStyle}
              handleUpdate={handleUpdate}
            />
          </div>
          <div className="text-[10px] text-addition1-70">
            I accept to receive my statements electronically, I understand that I will receive email notifications
            whenever my statements are ready to view.
          </div>
        </div>
      )}
    </div>
  );
}

export default AccountDelivery;
